export const ICON_STYLES = {
    closeBtn: {
        position: "absolute",
        right: "15px",
        top: "15px",
        cursor: "pointer",
        zIndex: "10"
    },
    closeIcon: { height: "35px", width: "35px" }
};



// WEBPACK FOOTER //
// ./src/components/Menu/icon_styles.jsx